
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './ProductPageFees.css';
import { TCreditCard } from '../../types/models/CreditCard';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { Row, Col, Section } from '../../importCL';

interface IProductPageFeesProps extends MappedComponentProperties {
    title?: string;
    cardFinderVariant?: boolean
    featuredCard?: TCreditCard;
}

export const ProductPageFeesEditConfig = {
    emptyLabel: 'Product Page Fees',
    isEmpty: (props: PropsWithChildren<IProductPageFeesProps>) => {
        return !props || !props.title;
    },
};

const ProductPageFees = (props: PropsWithChildren<IProductPageFeesProps>): JSX.Element => {
    const [termsLink, setTermsLink] = useState<string>(props.featuredCard?.staticLink as string);

    const annualFeeTitle = props.featuredCard?.annualFeeTitle ?? 'Annual Fee:';
    const annualFeeText = props.featuredCard?.annualFeeText ?? '$0';
    const aprTitle = props.featuredCard?.aprTitle ?? 'APR:';
    const aprPercentage = props.featuredCard?.aprLow ?? '25.00';
    const aprVariableRate = props.featuredCard?.aprText ?? '(Variable Rate)';
    const aprDisclaimer = props.featuredCard?.aprDisclaimer ?? 'See';
    const defaultTermsLinkText = props.featuredCard?.aprDisclaimerText ?? 'Terms, fees & conditions';

    useEffect(() => {
        if (props.featuredCard) {
            if (props.featuredCard.staticLink) {
                setTermsLink(props.featuredCard.staticLink);
            } else {
                setTermsLink(props.featuredCard.dynamicTermsLink);
            }

            if (props.featuredCard.aprLow === '0.0' || props.featuredCard.aprLow === '') {
                window.location.assign('/404');
            } 
        }
    }, []);

    return (
        <Section id='product-page-fees' className={`productPageFees ${props.cardFinderVariant ? 'productPageFees--cardFinderVariant' : ''}`} containerFluid title={props.title ?? 'Rates & Fees'}>
            <Row>
                <Col xs={3} md={6}>
                    <h5>{transformHTMLParserLinks(annualFeeTitle)}</h5>
                    <p>{transformHTMLParserLinks(annualFeeText)}</p>
                </Col>
                <Col xs={3} md={6}>
                    <h5>{transformHTMLParserLinks(aprTitle)}</h5>
                    <p className='productPageFees__percent'><strong>{aprPercentage}%</strong></p>
                    <p>{aprVariableRate}</p>
                </Col>
                <Col xs={6} md={12}>
                    <p>{aprDisclaimer} <LinkWrapper className='productPageFees__link' href={termsLink}>{transformHTMLParserLinks(defaultTermsLinkText)}</LinkWrapper></p>
                </Col>
            </Row>
        </Section>
    );
};

export default ProductPageFees;
